import dataList from '../../constants/dataList';

export const getCabinetTypeName = (key: string) => {
	let index = dataList.CabinetTypeDropdownList.findIndex((obj: { value: string }) => obj.value === key);
	return dataList.CabinetTypeDropdownList[index] ? dataList.CabinetTypeDropdownList[index].label : key;
};
